var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 117,
    viewBox: "0 0 122 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.23 3.01L101.05 21.47L83.22 39.93M50.55 3.01L68.37 21.47L50.54 39.93M20.84 3.01L38.66 21.47L20.83 39.93M3 39.93V99.96C3 107.6 8.98 113.79 16.35 113.79H105.53C112.9 113.79 118.88 107.6 118.88 99.96V39.93M3 39.93H118.88M3 39.93V18.39V13.17C3 7.55 7.39 3 12.81 3H109.06C114.48 3 118.87 7.55 118.87 13.16V39.93H118.88M121.27 21.47H5.39M48.33 57.99L72.93 71.1C74.76 72.08 74.76 74.79 72.93 75.77L48.33 88.87C46.64 89.77 44.63 88.5 44.63 86.54V73.44V60.33C44.64 58.36 46.64 57.09 48.33 57.99Z",
    stroke: "#164361",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121.88,
    height: 116.79,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.1af9d24564c9ad93d6f6010a4c3595de.svg";
export { ForwardRef as ReactComponent };